import React, { useId, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { H3 } from "components/core/Typography";
import "./DropdownItem.scss";

export default function DropdownItem({
	icon,
	label,
	buttonClassName,
	children
}) {
	const [isOpen, setIsOpen] = useState(false);
	const panelId = useId();
	return (
		<div className="slp-dropdown-item">
			<H3
				className="slp-dropdown-item__heading"
				last
			>
				<button
					type="button"
					className={classnames(
						"slp-dropdown-item__content",
						buttonClassName
					)}
					onClick={() => setIsOpen(!isOpen)}
					aria-expanded={isOpen}
					aria-controls={children ? panelId : undefined}
				>
					<span className="slp-dropdown-item__icon">{icon}</span>
					<span className="slp-dropdown-item__label">{label}</span>
					<svg
						className={`slp-dropdown-item__chevron${isOpen ? " slp-dropdown-item__chevron--open" : ""}`}
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<path
							d="M5 7.5L10 12.5L15 7.5"
							stroke="currentColor"
							strokeWidth="2.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
			</H3>
			{children && (
				<div
					id={panelId}
					className="slp-dropdown-item__panel"
					hidden={!isOpen}
				>
					{children}
				</div>
			)}
		</div>
	);
}

DropdownItem.propTypes = {
	icon: PropTypes.node.isRequired,
	label: PropTypes.string.isRequired,
	buttonClassName: PropTypes.string,
	children: PropTypes.node
};
